import utils from './utils'

// https://greensock.com/docs/v3/Installation
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// https://github.com/verlok/vanilla-lazyload
import LazyLoad from 'vanilla-lazyload'

const dataAttrSuffix = 'parallax'
const dataAttr = 'data-' + dataAttrSuffix
const layerLazySelector = '.layer-lazy'
let parallaxHeaderInstances = []

const getAttributeObject = function(str='') {
  // jquery .data() requires a data-name='{"name": "value"}' pattern, not good for minification
  const dataString = str.replace(/'/g, '"')
  let obj = {}
  try {
    obj = JSON.parse(dataString)
  } catch (e) {
    console.log(e)
  } finally {
    return obj
  }
}

class ParallaxHeader {
  constructor(target, args = {index: 0}) {
    this.target = target
    this.$el = $(this.target)
    this.tl = null
    this.$items = []

    this.id = dataAttrSuffix + '-' + args.index
    if(this.$el.attr('id')) {
      this.id = this.$el.attr('id')
    } else {
      this.$el.attr('id', this.id)
    }

    this.$el.prepend('<div class="progress-bar-wrapper"><div class="progress-bar"></div></div>')
    this.$progressBar = this.$el.find('.progress-bar')

    this.$items = this.$el.find('[' + dataAttr + '-layer]')

    this.$itemsWrapper = this.$el.find('[' + dataAttr + '-layers]').first()

    this.itemsWrapperHeight = 0 //itemsWrapperHeight cache
    this.init()
  }

  preloadComplete() {
    this.setTimeline()
    this.$el.addClass('ready')
    window.app.$html.removeClass('scroll-lock')
  }

  setTimeline() {
    const params_default = {
      trigger: this.target,
      start: 0, // "top " + window.app.headerHeight(), "top top" 50 "top bottom"
      // "bottom center" means "when the bottom of the endTrigger hits the center of the scroller".
      end:  "bottom center", //"bottom top", // "+=500"
      scrub: true, //0.1, would take 0.1 second to catch up
      //onToggle: self => console.log("toggled, isActive:", self.isActive),
    }
    let params = {}
    if(this.$el.attr(dataAttr)) {
      params = Object.assign({}, params_default, getAttributeObject(this.$el.attr(dataAttr)))
    } else {
      params = Object.assign({}, params_default)
    }

    this.tl = gsap.timeline({
      scrollTrigger: params
    })

    this.onResize()
  }

  onResize() {
    const itemsWrapperHeight = this.$itemsWrapper.height()
    let paddingBottom = false

    // prevent reinit on mobile, when address bar disapperars
    if (Math.abs(itemsWrapperHeight - this.itemsWrapperHeight) < 100) {
      return false
    }

    this.itemsWrapperHeight = itemsWrapperHeight

    // reste timeline and  positions
    // https://greensock.com/docs/v3/GSAP/Timeline/clear()
    this.tl.clear()
    this.$items.each((index, layer) => {
      gsap.set(layer, {
        y: 0,
        scaleX: 1,
        scaleY: 1
      })
    })
    //gsap.utils.toArray("#" + this.id + " [d' + dataAttr + '-item]")
    //this.$items.forEach(layer => {

    this.$items.each((index, layer) => {
      const depth = layer.dataset.depth
      const scale = layer.dataset.scale
      let props = {ease: 'none'}
      if (scale) {
        props.scaleX = scale
        props.scaleY = scale
        props.transformOrigin = 'top center'
        paddingBottom = true
      } else if (depth) {
        //props.y = (depth * 100) + '%' // (layer.offsetHeight * depth)
        props.y = (itemsWrapperHeight * depth) // percent of wrapper height, to support small absolute postioned layers
      }
      if (scale || depth) {
        this.tl.to(layer, props, 0)
      }
    })

    if (paddingBottom) {
      this.$itemsWrapper.addClass('p-b')
    } else {
      this.$itemsWrapper.removeClass('p-b')
    }
  }

  init() {
    window.app.$html.addClass('scroll-lock')

    // https://github.com/verlok/vanilla-lazyload
    let loadedCount = 0
    const loadedCountTotal = this.$el.find(layerLazySelector).length
    this.lazyLoadInstance = new LazyLoad({
        callback_loaded: (el)=>{
          // this.lazyLoadInstance.loadingCount
          // this.lazyLoadInstance.toLoadCount
          loadedCount ++
          this.$progressBar.width((loadedCount / loadedCountTotal * 100) + '%')
        },
        callback_finish: ()=>{
          setTimeout(()=>{
            this.preloadComplete()
          }, 100)
        },
        elements_selector: '#' + this.id + ' ' + layerLazySelector
    })
    this.lazyLoadInstance.loadAll()
  }
  destroy() {
    /*
    Kills the ScrollTrigger instance, immediately unpinning and restoring any pin-related changes made to the DOM by ScrollTrigger and removing all scroll-related listeners, etc. so that the instance is eligible for garbage collection.
    */
    if (this.tl) {
      this.tl.scrollTrigger.kill()
      this.tl.kill()
    }

    this.lazyLoadInstance.destroy()
  }
}

const onWindowResize = function(){
  if (parallaxHeaderInstances.length) {
    for(var i=0; i<parallaxHeaderInstances.length; i++){
      parallaxHeaderInstances[i].onResize()
    }
  }
}

const onWindowResizeThrottle = utils.throttle(onWindowResize, 200)

const init = function() {
  //if(window.app.isTouch()){
  $('[' + dataAttr + ']').each(function(index) {
    const spInstance = new ParallaxHeader(this, {index: index})
    parallaxHeaderInstances.push(spInstance)
  })

  $(window).on('resize', onWindowResizeThrottle)
}

const destroy = function() {
  //if(window.app.isTouch()){
  parallaxHeaderInstances.forEach(spInstance => {
    spInstance.destroy()
  })
  parallaxHeaderInstances = []

  $(window).off('resize', onWindowResizeThrottle)
}

export default {init, destroy}
